import React, { useEffect } from 'react'

// styles
import Styles from './warningModal.module.css'

// icons
import { ReactComponent as WarningIcon } from '../../../assets/icons/imported/alert.svg'

// redux
import { useDispatch, useSelector } from 'react-redux'

// components
import WenbitModal from '../../../components/Modal/Modal'
import Button from '../../../components/Button/Button'
import { setWarningModalOpen } from './redux/warningModalSlice'

function DangerModal({ open = false, handleClose }) {
  const accentColor = 'var(--warning-color)'
  const modalData = useSelector(state => state.warningModalState)
  const dispatch = useDispatch()

  useEffect(() => {
    // Check if the URL contains "/email-verification-required"
    if (window.location.pathname.includes("/email-verification-required") || window.location.pathname.includes("/accounts/confirmation")) {
      // Close the modal
      if (modalData && modalData.open) {
        // Assuming you have a function to close the modal
        // This could be dispatch(closeModal()) or similar depending on your setup
        dispatch(setWarningModalOpen(false)) // Adjust this to your actual modal close action
      }
    }
  }, [modalData, dispatch])

  return (
    <>
      <WenbitModal
        open={open}
        showCloseButton={true}
        onClose={handleClose}
        showLineHeader={true}
        lineHeaderColor={accentColor}
        render={() => (
          <div className={Styles.bodyContainer}>
            <WarningIcon color={accentColor} height={55} width={55} />
            <span className={Styles.title}>{modalData.data?.title}</span>
            <span className={Styles.description}>{modalData.data?.subtitle}</span>

            <div className={Styles.buttonsContainer}>
              <Button
                text='Cancel'
                variant='link'
                style={{
                  width: 'fit-content',
                  color: accentColor
                }}
                onClick={() => {
                  handleClose()
                }}
              />
              <Button
                text='Confirm'
                style={{
                  width: 'fit-content',
                  backgroundColor: accentColor
                }}
                onClick={() => {
                  // console.log(modalData)
                  modalData.data.callback ? modalData.data.callback() : handleClose()
                  handleClose()
                  // modalData.data?.callback()
                }}
              />
            </div>
          </div>
        )}
      />
    </>
  )
}

export default DangerModal
